import { ProgressSpinner } from "primereact/progressspinner"
import "./style.scss"

const Spinner = ({ ...props }) => {
  return <ProgressSpinner {...props} />
}

export default Spinner
